export default __webpack_public_path__ + "static/media/onboarding.0a52a123.svg";